import React from 'react'
import { Table } from '@themesberg/react-bootstrap'
import { getPercentageColor, getTextColor } from '../../utils/dashboardEffects'
const GameReportTable = ({ tableData, isPlayer }) => {
  return (
    <div style={{ overflow: 'auto', maxHeight: '385px' }}>
      <Table striped responsive hover size='sm' className='text-center mt-4'>
        <thead className='thead-light'>
          <tr>
            {isPlayer
              ? ['ID',
                'Name',
                'Number of Rounds',
                'Total Bets',
                'Total Wins',
                'GGR',
                'NGR'
              ].map((h) => (
                <th key={h}>{h}</th>
              ))
              : [
                'ID',
                'Name',
                'Number of Rounds',
                'Number of Player',
                'Total Bets',
                'Total Wins',
                'GGR',
                'NGR',
                'Handle'
              ].map((h) => (
                <th key={h}>{h}</th>
              ))}
          </tr>
        </thead>

        <tbody>
          {tableData && tableData.length > 0
            ? tableData.map(({ casinoGameId: id, name, numberOfRounds, totalPlayers: playerCount, loss: totalBet, win: win, GGR, NGR, payout, casino_game_id, handle }, idx) => {
              return (
                <tr key={`top-loosers ${casino_game_id}`}>
                  <td>{casino_game_id}</td>
                  <td style={{ textAlign: 'center' }}>
                    {name}
                  </td>
                  <td>{numberOfRounds || '0'}</td>
                  {!isPlayer && <td>{playerCount || '0'}</td>}
                  <td style={{ color: 'green' }}>$ {totalBet || '0'}</td>
                  <td style={{ color: 'red' }}>$ {win || '0'}</td>
                  <td className={`${getTextColor(GGR)}`}>$ {GGR || '0'} </td>
                  <td className={getTextColor(NGR)}>$ {NGR || '0'}</td>
                  <td>$ {handle || '0'}</td>
                </tr>
              )
            })
            : (
              <tr>
                <td colSpan={9} className='text-danger text-center'>
                  No data found
                </td>
              </tr>
            )}
        </tbody>
      </Table>
    </div>
  )
}

export default GameReportTable
